<template>
  <div
    class="c-header-image"
    :style="`background-image: url('${$store.state.baseUrl}${image}')`"
  />
</template>

<script>
export default {
  name: 'OHeaderImage',
  props: {
    image: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.c-header-image {
  background-position: center center;
  background-size: cover;
  flex: none;
  height: 22rem;
}
</style>
